import { render } from "./Bundles.vue?vue&type=template&id=e1c4401c"
import script from "./Bundles.vue?vue&type=script&lang=js"
export * from "./Bundles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__